/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForBlueprintExecution extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForBlueprintExecution");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForBlueprintExecution.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForBlueprintExecution>): BackgroundJobPayloadForBlueprintExecution {
        let obj = Object.assign(new BackgroundJobPayloadForBlueprintExecution(), model);
        BackgroundJobPayloadForBlueprintExecution.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForBlueprintExecution>): BackgroundJobPayloadForBlueprintExecution {
        if (!model) return null;
        return BackgroundJobPayloadForBlueprintExecution.newInstance(<BackgroundJobPayloadForBlueprintExecution> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForBlueprintExecution) {
        if (!obj) return;

        models.BackgroundJobPayloadForBlueprintExecution.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForBlueprintExecution): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForBlueprintExecution.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    job_id: string;

    execution_type: models.BlueprintExecutionOption;

    /**
     * parameters to blueprint
     */
    execution_params: any;

}
